<div class="container version-reload">
  <div class="version">
    Filmstacker {{ version }}
  </div>
  <ion-button class="reload-button" size="small" color="medium" fill="clear" (click)="presentReloadOptions()"
    title="Reload App">
    <ion-icon size="small" slot="icon-only" name="reload"></ion-icon>
  </ion-button>
</div>
